import {
  RESET_CPASSWORD,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_INVALID_REQUEST,
  NETWORK_ERROR_CPASSWORD,
  CHANGE_PASSWORD_INVALID_STRENGTH,
  LOADING_PASSWORD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  networkError: "",
  invalidStrength: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PASSWORD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        networkError: "",
        invalidStrength: false,
        data: {}
      };
    case CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        invalidStrength: false,
        failed: true,
        data: action.payload
      };
    case CHANGE_PASSWORD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        invalidStrength: false,
        failed: false,
        data: action.payload
      };

    case CHANGE_PASSWORD_INVALID_STRENGTH:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        invalidStrength: true,
        failed: false,
        data: action.payload
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        invalidStrength: false,
        success: true,
        invalidRequest: false,
        data: action.payload
      };

    case NETWORK_ERROR_CPASSWORD:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        invalidStrength: false,
        networkError: "Something went wrong"
      };

    case RESET_CPASSWORD:
      return (state = initialState);

    default:
      return state;
  }
};
